module.exports = __webpack_public_path__ + "img/olej.842cdee8.jpg";